import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { MensajeriaNew } from '../reutilizables/mensajeria/MensajeriaNew'
import * as mensajesService from '../servicios/mensajesService'
import * as presupuestosService from '../servicios/presupuestosService'
import BordeDetalle from '../ui/BordeDetalle'
import PresupuestoCabecera from './PresupuestoCabecera'
import PresupuestoForm from './PresupuestoForm'

const DetallePresupuesto = () => {
  const usuario = parseInt(localStorage.getItem('idUsuario'))
  const navigate = useNavigate()
  const { idPresupuesto } = useParams()
  const { canAdministrate } = useLocation().state || {}
  const [estado, setEstado] = useState(null)
  const [estadoTxt, setEstadoTxt] = useState(null)
  const [mensajes, setMensajes] = useState([])
  const [presupuesto, setPresupuesto] = useState({})

  const actualizarEstado = (estado) => {
    setEstado(1)
    setEstadoTxt(estado)
  }

  const buscarDetalle = async () => {
    const presupuesto = await presupuestosService.buscarPorId(idPresupuesto)
    setPresupuesto(presupuesto.data)
    await buscarMensajes()
  }

  const buscarMensajes = async () => {
    const { data } = await mensajesService.buscarPorPresupuesto(idPresupuesto)
    setMensajes(data.sort((a, b) => new Date(a.fechaEscrito) - new Date(b.fechaEscrito)))
  }

  useEffect(() => {
    idPresupuesto && buscarDetalle()
  }, [idPresupuesto])

  return (
    <BordeDetalle titulo={'Detalle Presupuesto'} onCerrarClick={() => navigate(-1)}>
      <PresupuestoCabecera
        presupuesto={presupuesto}
        estado={estado}
        estadoTxt={estadoTxt}
        canAdministrate={canAdministrate}
      />
      <PresupuestoForm
        idPresupuesto={idPresupuesto}
        presupuesto={presupuesto}
        handleEstado={actualizarEstado}
        usuarioId={usuario}
        canAdministrate={canAdministrate}
      />
      <MensajeriaNew
        titulo={'Preguntas'}
        idVendedor={presupuesto.idVendedor}
        idComprador={presupuesto.idUsuario}
        id={Number(idPresupuesto)}
        tipoDoc={'presupuesto'}
        mensajes={mensajes}
        tipoMensajes={'chat'}
        usuario={usuario}
        actualizarMensajes={buscarMensajes}
      />
    </BordeDetalle>
  )
}

export default DetallePresupuesto
